//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'QPassword',
	data: () => ({
		showText: false,
	}),
	computed: {
		slots() {
			const slots = {
				...this.$scopedSlots,
			};

			delete slots.append;

			return slots;
		},
	},
};
